import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FaceIcon from '@material-ui/icons/PermIdentity';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';
import grey from '@material-ui/core/colors/grey';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import Divider from '@material-ui/core/Divider';

import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText'

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ls from 'local-storage'

const styles = theme => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  button: {
    margin: theme.spacing.unit / 2,
    marginTop: 0,
    marginBottom: 0,
  },
  paper: {
    padding: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
  paperAddress: {
    padding: theme.spacing.unit,
    color: theme.palette.text.secondary,
    marginTop: 8,
  },
  formControl: {
    //margin: theme.spacing.unit,
  },
  formLabel: {
    textAlign: 'left',
  },
  formInput: {
    padding: 0,
  },
  gridItem: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  gridItemLabel: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingRight: 8,
    textAlign: 'right',
  },
  bigAvatar: {
    width: 100,
    height: 100,
  },
  maleAvatar: {
    width: 100,
    height: 100,
    margin: 10,
    color: '#fff',
    backgroundColor: blue[500],
  },
  femaleAvatar: {
    width: 100,
    height: 100,
    margin: 10,
    color: '#fff',
    backgroundColor: pink[500],
  },
  unassignedAvatar: {
    width: 100,
    height: 100,
    margin: 10,
    color: '#fff',
    backgroundColor: grey[500],
  },
});

const pstatedata = {
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    alt_email: '',
    alt_email_send: '',
    alt_patient_id: '',
    balance: '',
    block_appt: '',
    date_completed: '',
    date_entered: moment().format("YYYY-MM-DD"),
    default_priceband: '',
    dentist_id: '',
    dentistid:'',
    displayname: '',
    dob: moment().format("YYYY-MM-DD"),
    forenames: '',
    group_id: '',
    group_role: '',
    home_email: '',
    home_email_send: '',
    home_phone: '',
    hygieneonly: '',
    hygienist_displayname: '',
    hygienist_id: '',
    hygienistid:'',
    hygienist_initials: '',
    idxfti: '',
    initials: '',
    job: '',
    knownas: '',
    last_treatment_option: '',
    last_viewed: '',
    latlong: '',
    mailnews: '',
    mailother: '',
    mailrecall: '',
    mailreminder: '',
    mobile_phone: '',
    mobile_sms: '',
    next_recall_dentist: '',
    next_recall_hygienist: '',
    nhs_number: '',
    ni_number: '',
    patient_age: '',
    patient_displayname: '',
    patient_id: '',
    patient_picture: '',
    postcode: '',
    practice_id: '',
    practice_name: '',
    preferred_contact: '',
    previous_surname: '',
    quick_note: '',
    recall_interval_dentist: '',
    recall_interval_hygienist: '',
    referring_dentist: '',
    referring_dentist_name: '',
    scheme: '',
    scheme_colour: '',
    scheme_ld: '',
    scheme_link: '',
    scheme_sd: '',
    scheme_type: '',
    schemeid: '',
    search_colour: '',
    search_include: '',
    sex: '',
    status: '',
    status_code: '',
    status_colour: '',
    status_desc: '',
    surname: '',
    title: '',
    work_phone: '',
    lang: '',
    lead: '',
    ethorg: '',
};


class PatientDetails extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.newPatient = this.newPatient.bind(this);
        this.props = props;
        //this.setState({pdata: pstatedata});
    }

    state = {
        practice_id: 1,
        patient_id: this.props.patient_id,
        refresh: '',
        pdata: {},
        friendlydob:{year:"",month:"",day:""},
        snackopen:false,
        formErrors: {email: ''},
        emailValid: false,
        formValid: false,
        entered: [],
        duplicates: [],
        duplicateDialogOpen: false,
    };

    fetchConfig() {
        if (this._isMounted) {
            this.props.socket.emit("patient_config",{practiceid:this.state.practice_id,authenticator:ls.get("authenticator")});
        }
    };

    fetchData(pid) {
        this.setState({patient_id: pid});
        this.setState({pdata: {}});
        //this.setState({pdata: pstatedata});

        this.fetchConfig();

        if (this._isMounted) {
            this.props.socket.emit("patient_details",{patientid:this.state.patient_id,authenticator:ls.get("authenticator")});
        }
    }

    componentDidMount() {
        this._isMounted = true;

        this.setState({duplicates: []});

        let pstatedatacopy = Object.assign({}, pstatedata);
        this.setState({pdata: pstatedatacopy});

        if (this.state.patient_id){
            this.fetchData(this.state.patient_id);
        }else{
            this.fetchConfig();
            this.snackbarText="Creating new patient. Enter some details for the new patient."
            //this.setState({pdata:pstatedata});
            this.setState({ snackopen: true });
        }
        this.props.socket.on("patient_config_result",(d)=>{
            if (this._isMounted) {
                this.setState({config:d});
            }
        });

        this.props.socket.on("patient_details_result",(d)=>{
            //console.log(d);

            let pstatedatacopy = Object.assign({}, pstatedata);
            this.setState({pdata: pstatedatacopy});            

            let details = d;

            if (this._isMounted) {
                
                this.props.appstate.setState({currentPatientNameText:details.patient_displayname})
                this.props.appstate.setState({currentPatientSecondLine:"ID "+details.patient_id+" - "+details.displayname+ " - "+moment(details.dob, "YYYYMMDD").format("DD/MM/YYYY")});
                this.props.appstate.setState({currentPatientThirdLine:details.sex+" - Scheme: "+details.scheme_ld});

                this.setState({pdata:details});
            }

            //console.log({state: this.state});
        });

        this.props.socket.on("patient_save_result",(d)=>{
            //console.log(d);//
            
            if(d.patient_id!==this.state.pdata.patient_id){
                this.props.history.push("/patient/"+d.patient_id);
            }
        });

        this.props.socket.on("duplicate_check_result",(d)=>{
            //console.log(d);

            if (this._isMounted) {
                if (d.length > 0) {
                    //console.log('found: '+d.length+' possible duplicate patients');
                    this.setState({duplicates: d});

                    this.setState({duplicateDialogOpen: true});
                }
            }
            
            /*if(d.patient_id!==this.state.pdata.patient_id){
                this.props.history.push("/patient/"+d.patient_id);
            }*/
        });        

        
    }  

    componentWillUnmount() {
        this._isMounted = false;
    }    

    componentDidUpdate(prevProps){        
        if (this.props.patient_id !== prevProps.patient_id) {
            this.setState({patient_id: this.props.patient_id});
            this.props.socket.emit("patient_details",{patientid:this.props.patient_id,authenticator:ls.get("authenticator")});
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    savePatient = event => {
        //console.log('save button pressed');
        if(!this.state.patient_id){
            // new patient
            this.setState({patient_id:"new"});
            let pdatatmp = this.state.pdata;
            pdatatmp['patient_id'] = 'new';
            this.setState({pdata: pdatatmp});
        }
        this.props.socket.emit("patient_save", {pdata:this.state.pdata,authenticator:ls.get("authenticator")});
        //console.log(this.state.pdata);
    }

    cancelButton = event => {
      if(!this.state.patient_id || this.state.patient_id === "new"){
        this.snackbarText="Discarded new patient details"
        this.setState({ snackopen: true });
        let pstatedatacopy = Object.assign({}, pstatedata);
        this.setState({pdata: pstatedatacopy});
        //console.log('cancel button pressed');
      } else {

      }
    }

    async newPatient (event) {
        //await console.log(this.state);
        //await console.log(pstatedata);

        let pstatedatacopy = Object.assign({}, pstatedata);
        await this.setState({pdata: pstatedatacopy});
        await this.props.history.push("/patient/");

        await this.setState({patient_id: undefined});

        //await console.log(this.state);
    }

    closeSnack = (event,reason)=>{
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ snackopen: false });
    }

    handleClose = event => {
        this.setState({ duplicateDialogOpen: false });
    }

    handleListItemClick = event => {
        //console.log(event);
        this.props.history.push('/patient/'+event);
        this.setState({ duplicateDialogOpen: false });
    }  

    handleInputEnter (e) {
        let enteredstate = this.state.entered;

        enteredstate[e.target.name] = true;

        this.setState({entered: enteredstate});

        //console.log(this.state);
    }    

    handleTextChange = name => event => {
        let pdatatmp = this.state.pdata;
        pdatatmp[name] = event.target.value;
        this.setState({pdata: pdatatmp});

        this.validateField(name, event.target.value);
        
        //console.log(event.target);
    };

    handleDateChange = name => event => {
        let pdatatmp = this.state.pdata;
        pdatatmp[name] = moment(event).format("YYYY-MM-DD");
        this.setState({pdata: pdatatmp});
    };

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;

        switch(fieldName) {
            case 'home_email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = emailValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({formErrors: fieldValidationErrors,
                        emailValid: emailValid
                        }, this.validateForm);

        //console.log(this.state);
    }    

    checkDuplicate = event => {
        if (this.state.pdata.patient_id === 'new' || !this.state.pdata.patient_id) {
            if (this.state.pdata.surname && this.state.pdata.forenames && this.state.pdata.dob)
                this.props.socket.emit("duplicate_check", {pdata:this.state.pdata,authenticator:ls.get("authenticator")});
        }
    }

    renderDentistOptions() {
        if (this.state.config)
        {
            return this.state.config.dentists.map((dt, i) => {
                return (
                    <MenuItem
                    key={dt.staff_id}
                    value={dt.staff_id}>
                    {dt.displayname}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    } 
    
    renderHygienistOptions() {
        if (this.state.config)
        {
            return this.state.config.hygienists.map((dt, i) => {
                return (
                    <MenuItem
                    key={dt.staff_id}
                    value={dt.staff_id}>
                    {dt.displayname}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }  
    
    renderSchemeOptions() {
        if (this.state.config)
        {
            return this.state.config.schemes.map((dt, i) => {
                return (
                    <MenuItem
                    key={dt.schemeid}
                    value={dt.schemeid}>
                    {dt.scheme_sd}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }      

    renderStatusOptions() {
        if (this.state.config)
        {
            return this.state.config.status.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.status_code}>
                    {dt.status_desc}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }  
    
    renderTitleOptions() {
        if (this.state.config)
        {
            return this.state.config.titles.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.title_text}>
                    {dt.title_text}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }      

    renderLanguageOptions() {
        if (this.state.config)
        {
            return this.state.config.languages.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.data}>
                    {dt.label}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }       

    renderHeardFromOptions() {
        if (this.state.config)
        {
            return this.state.config.heardfrom.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.heard_id}>
                    {dt.heard_desc}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }   
    
    renderReferredByOptions() {
        if (this.state.config)
        {
            return this.state.config.referredby.map((dt, i) => {
                return (
                    <MenuItem
                    key={i}
                    value={dt.display_name}>
                    {dt.display_name}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }   

  render() {
    const { classes } = this.props;
    const { duplicates } = this.state;

    // set the class for the atavar depending on the gender
    let pavatarc;
    if (this.state.pdata.sex === 'M') {
        pavatarc = classes.maleAvatar;
    } else if (this.state.pdata.sex === 'F') {
        pavatarc = classes.femaleAvatar;
    } else {
        pavatarc = classes.unassignedAvatar;
    }

    return (
      <div className={classes.root}>

      <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.snackopen}
          autoHideDuration={6000}
          onClose={this.closeSnack}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id"><FaceIcon/> {this.snackbarText}</span>}
          action={[
            
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.closeSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />

        <Dialog onClose={this.handleClose} aria-labelledby="duplicate-dialog-title" open={this.state.duplicateDialogOpen}>
            <DialogTitle id="duplicate-patient-title">Duplicate Patient's Found</DialogTitle>
            <List>
                {duplicates.map(patient => (
                <ListItem button onClick={() => this.handleListItemClick(patient.patient_id)} key={patient.patient_id}>
                    <ListItemText primary={patient.patient_id+' | '+patient.title+' '+patient.forenames+' '+patient.surname} />
                </ListItem>
                ))}
                <Divider />
                <ListItem button onClick={this.handleClose}>
                    <ListItemText primary="Continue with new patient" />
                </ListItem>                
            </List>
        </Dialog>        

        <Grid container style={{ padding: 2 }} spacing={1}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
                <Button variant="contained" color="primary" className={classes.button} onClick={this.savePatient}>Save</Button>
                <Button variant="contained" color="secondary" className={classes.button} onClick={this.cancelButton}>Cancel</Button>
                
                {this.state.patient_id ? <Button variant="contained" style={{float:"right",backgroundColor:"#00BB00",color:"#FFF"}} 
                    className={classes.button} onClick={this.newPatient}>New patient</Button> : null }
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={4}>
                  <Avatar alt="Patient Avatar" className={pavatarc} >
                    <FaceIcon style={{fontSize: 78}}/>
                  </Avatar>
                </Grid>
                <Grid item xs={12} sm={12} md={8}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-preferred">Preferred Name</InputLabel>
                    <Input id="patient-preferred" placeholder=""
                        value={this.state.pdata.knownas} 
                        onChange={this.handleTextChange('knownas')}/>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                 <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-quicknote">Quick note</InputLabel>
                    <Input id="patient-quicknote" multiline={true} rows="5" placeholder=""
                        value={this.state.pdata.quick_note} onChange={this.handleTextChange('quick_note')}/>
                  </FormControl>                
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={2}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-title">Title</InputLabel>
                    <Select
                      value={this.state.pdata.title}
                      onChange={this.handleTextChange('title')}
                      inputProps={{
                        name: 'title',
                        id: 'patient-title',
                      }}
                    >
                        <MenuItem/>
                        {this.renderTitleOptions()}
                    </Select>                    
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={5}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-surname">Surname</InputLabel>
                    <Input id="patient-surname" placeholder="" name="surname"
                        value={this.state.pdata.surname} onChange={this.handleTextChange('surname')}
                        onBlur={this.checkDuplicate}/>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={5}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-previous">Previous</InputLabel>
                    <Input id="patient-previous" placeholder="" name="previous"
                        value={this.state.pdata.previous_surname} onChange={this.handleTextChange('previous_surname')}/>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-forenames">Forenames</InputLabel>
                    <Input id="patient-forenames" placeholder=""
                        value={this.state.pdata.forenames} onChange={this.handleTextChange('forenames')}
                        onBlur={this.checkDuplicate}/>
                  </FormControl>
                </Grid> 
                <Grid item xs={12} sm={12} md={4} lg={6}/>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    {/*<TextField
                      id="patient-dob"
                      label="DOB"
                      type="date"
                      value={moment(this.state.pdata.dob, "YYYYMMDD").format("YYYY-MM-DD")}
                      onChange={this.handleTextChange('dob')}
                      onBlur={this.checkDuplicate}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />*/}
                    <InputLabel shrink htmlFor="patient-dob">DOB</InputLabel>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                            clearable
                            autoOk
                            disableFuture
                            id="patient-dob"
                            label=" "
                            value={moment(this.state.pdata.dob, "YYYYMMDD")}
                            onChange={this.handleDateChange('dob')}
                            format="dd/MM/yyyy"
                      /> 
                    </MuiPickersUtilsProvider>          
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-gender">Gender</InputLabel>
                    <Select
                      value={this.state.pdata.sex}
                      onChange={this.handleTextChange('sex')}
                      inputProps={{
                        name: 'sex',
                        id: 'patient-gender',
                      }}
                    >
                      <MenuItem value="U">Unspecified</MenuItem>
                      <MenuItem value="M">Male</MenuItem>
                      <MenuItem value="F">Female</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={6}/>
           
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-language">Language</InputLabel>
                    <Select
                      value={this.state.pdata.lang}
                      onChange={this.handleTextChange('lang')}
                      inputProps={{
                        name: 'lang',
                        id: 'patient-lang',
                      }}
                    >
                        <MenuItem/>
                        {this.renderLanguageOptions()}
                    </Select>                    
                  </FormControl>
                </Grid>  
                {/*<Grid item xs={12} sm={12} md={1} lg={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-ethorg">Ethnic Origin</InputLabel>
                    <Select
                      value={this.state.pdata.ethorg}
                      onChange={this.handleTextChange('ethorg')}
                      inputProps={{
                        name: 'ethorg',
                        id: 'patient-ethorg',
                      }}
                    >
                        <MenuItem/>
                        <MenuItem value="99">Patient Declined</MenuItem>
                        <MenuItem value="01">White British</MenuItem>
                        <MenuItem value="02">White Irish</MenuItem>
                        <MenuItem value="03">White Other</MenuItem>
                        <MenuItem value="04">White and Black Caribbean</MenuItem>
                        <MenuItem value="05">White and Black African</MenuItem>
                        <MenuItem value="06">White and Asian</MenuItem>
                        <MenuItem value="07">Other Mixed Background</MenuItem>
                        <MenuItem value="08">Asian or Asian British Indian</MenuItem>
                        <MenuItem value="09">Asian or Asian British Pakistani</MenuItem>
                        <MenuItem value="10">Asian or Asian British Bangladeshi</MenuItem>
                        <MenuItem value="11">Other Asian Bbackground</MenuItem>
                        <MenuItem value="12">Black or Black British Caribbean</MenuItem>
                        <MenuItem value="13">Black or Black British African</MenuItem>
                        <MenuItem value="14">Other Black Background</MenuItem>
                        <MenuItem value="15">Chinese</MenuItem>
                        <MenuItem value="16">Any Other Ethnic Group</MenuItem>
                    </Select>                    
                  </FormControl>                   
                    </Grid> */}
              </Grid>         
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <TextField
                      id="patient-joined"
                      label="Joined Practice"
                      type="date"
                      onChange={this.handleTextChange('date_entered')}
                      value={moment(this.state.pdata.date_entered, "YYYYMMDD").format("YYYY-MM-DD")}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-status">Status</InputLabel>
                    <Select
                      value={this.state.pdata.status}
                      onChange={this.handleTextChange('status')}
                      inputProps={{
                        name: 'status',
                        id: 'patient-status',
                      }}
                    >
                        <MenuItem/>
                        {this.renderStatusOptions()}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-nhsno">NHS Number</InputLabel>
                    <Input id="patient-nhsno" placeholder=""
                        value={this.state.pdata.nhs_number} onChange={this.handleTextChange('nhs_number')}/>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-scheme">Scheme</InputLabel>
                    <Select
                      value={this.state.pdata.schemeid}
                      onChange={this.handleTextChange('schemeid')}
                      inputProps={{
                        name: 'schemeid',
                        id: 'patient-scheme',
                      }}
                    >
                        <MenuItem/>
                        {this.renderSchemeOptions()}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-nhsno">National Insurance Number</InputLabel>
                    <Input id="patient-nhsni" placeholder=""
                        value={this.state.pdata.ni_number} onChange={this.handleTextChange('ni_number')}/>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-schemeno">Scheme Number</InputLabel>
                    <Input id="patient-schemeno" placeholder=""
                        value={this.state.pdata.alt_patient_id} onChange={this.handleTextChange('alt_patient_id')}/>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-dentist">Dentist</InputLabel>
                    <Select
                      value={this.state.pdata.dentist_id}
                      onChange={this.handleTextChange('dentist_id')}
                      inputProps={{
                        name: 'dentistid',
                        id: 'patient-dentist',
                      }}
                    >
                        <MenuItem/>
                        {this.renderDentistOptions()}
                    </Select>
                  </FormControl>
                </Grid>                
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-referred">Referred by</InputLabel>
                    <Select
                      value={this.state.pdata.referring_dentist_name}
                      onChange={this.handleTextChange('referring_dentist_name')}
                      inputProps={{
                        name: 'referring_dentist',
                        id: 'patient-referring-dentist',
                      }}
                    >
                        <MenuItem/>
                        {this.renderReferredByOptions()}
                    </Select>                    
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-hygienist">Hygienist</InputLabel>
                    <Select
                      value={this.state.pdata.hygienist_id}
                      onChange={this.handleTextChange('hygienist_id')}
                      inputProps={{
                        name: 'hygienistid',
                        id: 'patient-hygienist',
                      }}
                    >
                        <MenuItem/>
                        {this.renderHygienistOptions()}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel shrink htmlFor="patient-heardfrom">Heard from</InputLabel>
                    <Select
                      value={this.state.pdata.lead}
                      onChange={this.handleTextChange('lead')}
                      inputProps={{
                        name: 'lead',
                        id: 'patient-lead',
                      }}
                    >
                        <MenuItem/>
                        {this.renderHeardFromOptions()}
                    </Select>                    
                  </FormControl>
                </Grid>                
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
              <Paper className={classes.paper}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-address1">House Name</InputLabel>
                      <Input id="patient-address1" placeholder=""
                        onChange={this.handleTextChange('address1')}
                        value={this.state.pdata.address1}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-address2">No. &amp; Street</InputLabel>
                      <Input id="patient-address2" placeholder=""
                        onChange={this.handleTextChange('address2')}
                        value={this.state.pdata.address2}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-address3">District</InputLabel>
                      <Input id="patient-address3" placeholder=""
                        onChange={this.handleTextChange('address3')}
                        value={this.state.pdata.address3}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-address4">Town</InputLabel>
                      <Input id="patient-address4" placeholder=""
                        onChange={this.handleTextChange('address4')}
                        value={this.state.pdata.address4}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-address5">County</InputLabel>
                      <Input id="patient-address5" placeholder=""
                        onChange={this.handleTextChange('address5')}
                        value={this.state.pdata.address5}/>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                      <InputLabel shrink htmlFor="patient-postcode">Postcode</InputLabel>
                      <Input id="patient-postcode" placeholder=""
                        onChange={this.handleTextChange('postcode')}
                        value={this.state.pdata.postcode}/>
                    </FormControl>
                  </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                        <InputLabel shrink htmlFor="patient-home_phone">Home Phone</InputLabel>
                        <Input id="patient-home_phone" placeholder=""
                        onChange={this.handleTextChange('home_phone')}
                        value={this.state.pdata.home_phone}/>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                        <InputLabel shrink htmlFor="patient-mobile_phone">Mobile Phone</InputLabel>
                        <Input id="patient-mobile_phone" placeholder=""
                        onChange={this.handleTextChange('mobile_phone')}
                        value={this.state.pdata.mobile_phone}/>
                        </FormControl>
                    </Grid>          
                    <Grid item xs={12}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                        <InputLabel shrink htmlFor="patient-home_email">Home Email</InputLabel>
                        <Input id="patient-home_email" name="home_email" placeholder=""
                        error={ (!this.state.emailValid && this.state.entered["home_email"] === true) ? true : false}
                        onBlur={(event) => this.handleInputEnter(event)}
                        onChange={this.handleTextChange('home_email')}
                        value={this.state.pdata.home_email}/>
                        </FormControl>
                    </Grid>            
                </Grid>
            </Paper>
        </Grid>

        </Grid>        
      </div>      
    );
  }
}

export default withStyles(styles)(PatientDetails);